import React, { useMemo, useState } from 'react'
import BasicText from '../../../components/Text/BasicText'
import { Col, Row } from 'antd'
import { Colors } from '../../../config'
import GenerateReport from './GenerateReport'
import { Link } from 'react-router-dom'
import { IoArrowBack } from 'react-icons/io5'
import { getReportTypes, REPORT_TYPES } from './helper'

const Reports = () => {
    const [drawerStates, setDrawerStates] = useState({
        reportType: REPORT_TYPES.grouped,
        reportDrawer: false
    })

    const onCloseDrawer = () => {
        setDrawerStates({ ...drawerStates, reportDrawer: false })
    }

    const onOpenDrawer = (reportType) => {
        setDrawerStates({ reportDrawer: true, reportType })
    }

    const reportTypes = useMemo(() => getReportTypes({ onOpenDrawer }), [onOpenDrawer])

    return (
        <>
            <Row align={"middle"} justify={"start"} className='flex items-center gap-3 my-5'>
                <Link to="/security-issues" className='flex items-center gap-2 cursor-pointer' style={{ color: '#555' }}>
                    <IoArrowBack size={18} />
                    {/* <span>Back</span> */}
                </Link>
                <BasicText text={'Security Issues'} className='text-xl font-semibold' />
            </Row>
            <Row gutter={[12, 12]}>
                {reportTypes.map(({ label, icon, onClick }) => {
                    return <Col
                        xl={6} lg={8} sm={12} xs={24}
                    >
                        <div
                            onClick={onClick}
                            style={{ background: Colors.White, boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} className='h-full flex items-center gap-3 px-4 py-6 rounded-md cursor-pointer hover:scale-x-105 hover:scale-y-105 duration-500 ease-in-out delay-75'>
                            <img src={icon} height={50} width={50} />
                            <div>
                                <BasicText text={label} className='text-lg font-semibold'
                                />
                            </div>

                        </div>
                    </Col>
                })}
            </Row>

            <GenerateReport
                openDrawer={drawerStates?.reportDrawer}
                onCloseDrawer={onCloseDrawer}
                reportType={drawerStates.reportType}
            />
        </>
    )
}

export default Reports